module.exports = __webpack_public_path__ + "static/img/3.82b87e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/3.png
// module id = qhCv
// module chunks = 0